export default __webpack_public_path__ + "static/media/carosello2.fda9b5cd.png";